@if (item) {
  <mat-form-field (click)="loadUniqueValues()" hideRequiredMarker>
    <mat-label>
      {{ item.label }}
      @if (item.required) {
        <em i18n="@@core.common.required">(required)</em>
      }
    </mat-label>
    @if (item.allowValueListOnly === false) {
      <input type="text"
             [placeholder]="item.placeholder || item.label"
             matInput
             [formControl]="formControl"
             [matAutocomplete]="auto">
      <mat-autocomplete [requireSelection]="item.allowValueListOnly"
                        [displayWith]="displayLabel"
                        #auto="matAutocomplete">
        @if (loading) {
          <mat-option><mat-spinner color="primary" diameter="20"></mat-spinner></mat-option>
        } @else {
          @for (option of options; track $index) {
            <mat-option [value]="option.value">{{option.label || option.value}}</mat-option>
          }
        }
      </mat-autocomplete>
    } @else {
      <mat-select [placeholder]="item.placeholder || item.label" [formControl]="formControl">
        @if (loading) {
          <mat-option><mat-spinner color="primary" diameter="20"></mat-spinner></mat-option>
        } @else {
          @for (option of options; track $index) {
            <mat-option [value]="option.value">{{option.label || option.value}}</mat-option>
          }
        }
      </mat-select>
    }
  </mat-form-field>
}
